var map = {
	"./ Aipo e produtos à base de aipo.svg": 437,
	"./ Soja e produtos à base de soja.svg": 438,
	"./Crustáceos e produtos à base de crustáceos.svg": 439,
	"./Dióxido de enxofre.svg": 440,
	"./Frutos de casca rija.svg": 441,
	"./Moluscos e produtos à base de moluscos.svg": 442,
	"./Mostarda e produtos à base de mostarda.svg": 443,
	"./Peixes e produtos à base de peixe.svg": 444,
	"./Sementes de sésamo e produtos à base de sementes de sésamo.svg": 445,
	"./Tremoço e produtos à base de tremoço.svg": 446,
	"./bad.svg": 447,
	"./cards.svg": 448,
	"./de.svg": 449,
	"./en.svg": 450,
	"./es.svg": 451,
	"./excelent.svg": 452,
	"./fr.svg": 453,
	"./good.svg": 454,
	"./it.svg": 455,
	"./list.svg": 456,
	"./my-pick-nav.svg": 457,
	"./my-pick_actives.svg": 458,
	"./my-pick_inactive.svg": 459,
	"./nav.svg": 460,
	"./nav2.svg": 461,
	"./nl.svg": 462,
	"./ok.svg": 463,
	"./pickly-white.svg": 464,
	"./pt.svg": 465,
	"./terrible.svg": 466
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;



/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons ^\.\/.*\.svg$
 ** module id = 184
 ** module chunks = 0
 **/